<script>
  import {
    push
  } from 'svelte-spa-router'
  export let invert
</script>

<div class="invert"style="padding: 20px;">
<h2>End Page</h2>
<h5>Thank You</h5>
<p>We Welcome any <a href="https://docs.google.com/forms/d/e/1FAIpQLSdmwyYykVzwX0ga_EjwRuuiOvFI6aNtlxX9pHdPrc_hD9Kzyw/viewform">Feedback</a></p>
<p>If you enjoyed the experience please consider donating the price of a coffee or two so we can continue to make these theatrical experiments!
</p>
<a href='https://ko-fi.com/M4M81JYWQ' target='_blank'><img height='36' style='border:0px;height:36px;' src='https://cdn.ko-fi.com/cdn/kofi3.png?v=2' border='0' alt='Buy Me a Coffee at ko-fi.com' /></a>
<a on:click={() => push('/')}><p>Go Back</p></a>
</div>
